import React from "react";
import { Button, Container } from "react-bootstrap";
import "./LoginBanner.css";
import { AiOutlineLock,AiFillGoogleCircle } from "react-icons/ai";
import { BsEnvelope,BsFacebook } from "react-icons/bs";
import { MdTextsms } from "react-icons/md";
import {Link} from 'react-router-dom'
const LoginBanner = () => {
  return (
    <div>
      <Container fluid className="p-0">
        <div className="row">
          <div className="col-12 col-md-6 p-0">
            <div className="login-img-container">
              <img
                src="https://img.freepik.com/free-photo/female-friends-out-shopping-together_53876-25041.jpg?w=1380&t=st=1659165741~exp=1659166341~hmac=75193db2d138591c5ac4176f14f1bcac29d242f971b260953b8cc15b3e7f5ffd"
                alt=""
                className="h-100 w-100"
              />
            </div>
          </div>
          <div className="col-12 col-md-6 p-0">
            <div className="login-form-container">
                {/* <div className="login-options">
                    <AiFillGoogleCircle className="my-3 fs-3 text-danger"/>
                    <BsFacebook className="my-3 fs-4 text-primary"/>
                    <MdTextsms className="my-3 fs-4 text-success"/>
                </div> */}
              <div className="login-form">
                <div>
                  <div className="login-logo">
                    <img
                    className="w-100"
                      src={require("../../../images/logo/gApparel.png")}
                      alt=""
                    />
                  </div>
                  <form>
                    <div className="email-container mb-3 d-flex align-items-center">
                        <BsEnvelope className="fs-2 text-primary"/>
                        <input className="ps-3 border-0 w-100 bg-transparent text-dark" placeholder="Your Email Address" type="email" />
                    </div>
                    <div className="mb-3">
                    <div className="email-container d-flex align-items-center">
                        <AiOutlineLock className="fs-2 text-primary"/>
                        <input className="ps-3 border-0 w-100 bg-transparent text-dark"  placeholder="Your Password" type="password" />
                    </div>
                    <div className="text-end">
                        <span>forgot password?</span>
                    </div>
                    </div>
                    <div>
                    <Link to="/"><Button className="py-2 px-3 w-100" variant="primary">Submit</Button></Link>
                    </div>
                  </form>
                  <div>
                    <p>First time here?<Link to="#">Register Now</Link></p>
                  </div>
                  <div className="login-options">
                    <AiFillGoogleCircle className="my-3 fs-3 text-danger"/>
                    <BsFacebook className="my-3 fs-4 text-primary"/>
                    <MdTextsms className="my-3 fs-4 text-success"/>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LoginBanner;
